import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "../redux/leadActivitySagas";
import { Menu, MenuItem } from "@szhsin/react-menu";
import { PlusIcon } from "../../../../assets/images/svg";

const AddTrackDropdown = () => {
  const dispatch = useDispatch();
  const filtersList = useSelector((state) => state.leadActivity.filtersList);
  const startFromOptions = useSelector((state) => state.leadActivity.startFromOptions);

  return filtersList.length === 5 ? null : (
    <Menu
      menuButton={() => (
        <div className="add-action-button">
          <span>Add New Action</span>
          <PlusIcon />
        </div>
      )}
      onClick={({ target }) => {
        dispatch(
          actionCreators.addFiltersGroup({
            start_from: { name: target.innerHTML, id: target.id },
            index: filtersList.length
          })
        );
      }}
    >
      {startFromOptions.map((elem) => (
        <MenuItem id={elem.id} key={elem.id}>
          {elem.name}
        </MenuItem>
      ))}
    </Menu>
  );
};

export default AddTrackDropdown;
